import { AxiosPromise } from 'axios';

import api from './api';

import { Plan } from '~/models/lifes';

export default class LifesService {
  static PER_PAGE_DEFAULT = 8;

  static getAllLifes(): AxiosPromise<Plan[]> {
    return api.get(`/lead-type`);
  }

  static createLife(params: {
    name: string;
    credit_price: number;
  }): AxiosPromise<Plan> {
    return api.post('/lead-type/create', params);
  }

  static updateLife(
    id: string,
    params: { name: string; credit_price: number },
  ): AxiosPromise<Plan> {
    return api.put(`/lead-type/${id}/update`, params);
  }

  static deleteLife(id: string): AxiosPromise<void> {
    return api.delete(`/lead-type/${id}/delete`);
  }
}
